import { send as sendMetric } from "./Metric";
import { track as eventTrack } from "./EventTracker";

const STORAGE_KEY = "event-queue";

const push = eventData => {
	let queue = JSON.parse(localStorage.getItem(STORAGE_KEY));
	if (!queue) {
		queue = [];
	}
	queue.push(eventData);
	localStorage.setItem(STORAGE_KEY, JSON.stringify(queue));
};

/**
 * Adds an event to the queue, which will be fired on next page load
 */
export function addEventTrackerData(
	eventCategory,
	eventAction,
	eventLabel,
	eventValue,
) {
	push({
		type: "event-tracking",
		eventCategory,
		eventAction,
		eventLabel,
		eventValue,
	});
}

/**
 * Adds a metric to the queue, which will be fired on next page load
 */
export function addMetricTrackerData(metric, value) {
	push({
		type: "metric",
		metric: metric,
		value: value,
	});
}

/**
 * Fires all the queued tracker events
 */
export function fire() {
	let queue = JSON.parse(localStorage.getItem(STORAGE_KEY));
	if (queue) {
		queue.forEach(element => {
			if (element.type === "event-tracking") {
				eventTrack(
					element.eventCategory,
					element.eventAction,
					element.eventLabel,
					element.eventValue,
				);
			}
			if (element.type === "metric") {
				sendMetric(element.metric, element.value);
			}
		});
		localStorage.removeItem(STORAGE_KEY);
	}
}

export default {
	addEventTrackerData,
	addMetricTrackerData,
	fire,
};
